
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { currentUrl } from "../../../../utils/helper";
import { handleGmailOAuthReturn } from "./gmailAuthReturnHandler";
import SimpleSpinner from "../../../loader";

// Shared Google OAuth callback route for BOTH the personal (Messaging > Email) and the organization
// (My Organization > Email) Gmail connections. They share this single redirect_uri — the only one
// registered as authorized in Google Cloud Console for the app's OAuth client — because Google
// rejects any redirect_uri that isn't pre-registered. The `state` param (echoed back unchanged by
// Google) is how the two flows are told apart; see gmailAuthReturnHandler.ts / oauthRedirect.ts's
// ORG_GMAIL_OAUTH_STATE.
const GmailAuthReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');

    handleGmailOAuthReturn(code, state, `${currentUrl}/callback/gmail`).then(navigate);
  }, [location.search, navigate]);

  return (
    <div className="spinnerContainer">
      <SimpleSpinner />
    </div>
  );
};

export default GmailAuthReturn;
